<template>
	<div class="flex flex-grow">
		<div class="md:gap-1 flex-grow items-baseline">
			<div class="flex space-x-4">
				<div class="text-left flex w-full">
					<div class="space-x-4 flex flex-grow flex-row">
						<div class="flex flex-col flex-grow w-full">
							<div class="grid md:grid-cols-2 gap-4" v-if="!isLoading">
								<BaseInputNumber
									v-model="damageAssessorCompany.cost_per_photo"
									ref="BaseInputNumber.cost_per_photo"
									:label="$t('cost_per_photo')"
									:sublabel="$t('first_photo_set')"
									:precision="2"
									:required="true"
								/>
								<BaseInputNumber
									v-model="damageAssessorCompany.cost_per_photo_duplicate"
									ref="BaseInputNumber.cost_per_photo_duplicate"
									:label="$t('cost_per_photo')"
									:sublabel="$t('per_second_copy')"
									:precision="2"
									:required="true"
								/>
								<BaseInputNumber
									v-model="damageAssessorCompany.writing_cost_per_page"
									ref="BaseInputNumber.writing_cost_per_page"
									:label="$t('writing_costs_per_page')"
									:precision="2"
									:required="true"
								/>
								<BaseInputNumber
									v-model="damageAssessorCompany.writing_cost_per_page_duplicate"
									ref="BaseInputNumber.writing_cost_per_page_duplicate"
									:label="$t('writing_costs_per_page')"
									:sublabel="$t('per_second_copy')"
									:precision="2"
									:required="true"
								/>
								<BaseInputNumber
									v-model="damageAssessorCompany.postage_phone"
									ref="BaseInputNumber.postage_phone"
									:label="$t('postage_phone')"
									:sublabel="$t('lump_sum')"
									:precision="2"
									:required="true"
								/>
								<BaseInputNumber
									v-model="damageAssessorCompany.travel_costs_per_km"
									ref="BaseInputNumber.travel_costs_per_km"
									:label="$t('driving_costs_per_km')"
									:precision="2"
									:required="true"
								/>
								<BaseInputNumber
									v-model="damageAssessorCompany.maximum_billed_km"
									ref="BaseInputNumber.maximum_billed_km"
									:label="$t('max_billed_km')"
									:precision="0"
									:value-range="{ min: 0, max: 99 }"
									:currency="{ prefix: '', suffix: ' km' }"
									:required="true"
								/>
								<BaseInputNumber
									v-model="damageAssessorCompany.cost_error_memory_readout"
									ref="BaseInputNumber.cost_error_memory_readout"
									:label="$t('read_error_log')"
									:precision="2"
									:required="true"
								/>
								<BaseInputNumber
									v-model="damageAssessorCompany.residual_value_exchange"
									ref="BaseInputNumber.residual_value_exchange"
									:label="$t('salvage_exchange')"
									:precision="2"
									:required="true"
								/>
								<BaseInputNumber
									v-model="damageAssessorCompany.cost_provision_of_original_image_files"
									ref="BaseInputNumber.cost_provision_of_original_image_files"
									:label="$t('provision_original_image_data')"
									:precision="2"
									:required="true"
								/>
								<BaseInputNumber
									v-model="damageAssessorCompany.layer_thickness_measurement"
									ref="BaseInputNumber.layer_thickness_measurement"
									:label="$t('layer_thickness_measurement')"
									:precision="2"
									:required="true"
								/>
								<BaseInputNumber
									v-model="damageAssessorCompany.cost_fetch_calculation_software"
									ref="BaseInputNumber.cost_fetch_calculation_software"
									:label="$t('cost_fetch_calculation_software')"
									:precision="2"
									:required="true"
								/>
							</div>
							<LoadingSpinner v-else />
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import BaseInputNumber from '@/components/forms/inputs/BaseInputNumber.vue';
import CompanyRepository from '@/api/repositories/CompanyRepository';
import LoadingSpinner from '@/components/navigation/LoadingSpinner.vue';
import Validate from "@/mixins/Validate";

export default {
	components: { LoadingSpinner, BaseInputNumber },
	name: 'OnboardingCompanyExtraCosts',
  mixins:[Validate],
	data() {
		return {
			isLoading: false,
			damageAssessorCompany: {},
		};
	},
	mounted() {
		this.isLoading = true;
		this.getExtraCosts();
	},
	methods: {
		getExtraCosts() {
			new CompanyRepository()
				.getDamageAssessorCompanyExtraCosts()
				.then(response => {
					this.damageAssessorCompany = response.data;
					this.isLoading = false;
				})
				.catch(e => {
					console.log(e);
					this.isLoading = false;
				});
		},
    getData(){
      return this.damageAssessorCompany

    }
	},
};
</script>
